module.exports = __webpack_public_path__ + "static/media/polandTagsMobileLarge.1f16510e.png";